export default "__VITE_ASSET__D2hz6JmN__"